import React, { useState } from "react";
import apiService from "../../services/apiService";
import "./ChangePasswordModal.css";

export default function ChangePasswordModal({ onSuccess }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      return setError("All fields are required.");
    }

    if (newPassword.length < 6) {
      return setError("New password must be at least 6 characters.");
    }

    if (newPassword !== confirmPassword) {
      return setError("New password and confirm password do not match.");
    }

    try {
      setLoading(true);

      await apiService.changePassword(currentPassword, newPassword);

      const user = JSON.parse(localStorage.getItem("user") || "{}");
      user.MustChangePassword = 0;
      localStorage.setItem("user", JSON.stringify(user));

      onSuccess?.();
    } catch (err) {
      setError(err?.message || "Failed to change password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cp-modal-overlay">
      <div className="cp-modal">
        <div className="cp-modal-header">
          <div>
            <h2>Change Password</h2>
            <p>
              For security, you need to update your temporary password before
              continuing.
            </p>
          </div>
        </div>

        {error && <div className="cp-alert-error">{error}</div>}

        <form className="cp-form" onSubmit={handleSubmit}>
          <div className="cp-field">
            <label>Current Password</label>
            <div className="cp-input-wrap">
              <input
                type={showCurrent ? "text" : "password"}
                placeholder="Enter current password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="cp-toggle"
                onClick={() => setShowCurrent((v) => !v)}
              >
                {showCurrent ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div className="cp-field">
            <label>New Password</label>
            <div className="cp-input-wrap">
              <input
                type={showNew ? "text" : "password"}
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="new-password"
              />
              <button
                type="button"
                className="cp-toggle"
                onClick={() => setShowNew((v) => !v)}
              >
                {showNew ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div className="cp-field">
            <label>Confirm New Password</label>
            <div className="cp-input-wrap">
              <input
                type={showConfirm ? "text" : "password"}
                placeholder="Re-enter new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
              />
              <button
                type="button"
                className="cp-toggle"
                onClick={() => setShowConfirm((v) => !v)}
              >
                {showConfirm ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div className="cp-note">
            Password must be at least 6 characters.
          </div>

          <button className="cp-submit" type="submit" disabled={loading}>
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
}